<template>
    <div class="bottom">
        <div class="box">
            <div class="friend-link">友情链接:</div>
            <div style="min-height: 40px;text-align: center">
                <a v-for="(item,key) in friendlyLinkList" :key="key" target="_blank" style="margin-right: 30px"
                   :href="item.dictValue">
                    {{item.dictLabel}}
                </a>
            </div>
            <div style="height: 1px;width: 1000px;margin: auto">
                <a-divider style="height: 1px;border: 1px solid #545454"/>
            </div>
            <div class="company">Copyright © 2017-2025 石家庄天亮教育科技有限公司 备案号:冀ICP备17020003号</div>
        </div>
    </div>
</template>
<script>
    import {friendlyLink} from "@api/friendly-link-api"

    export default {
        data() {
            return {
                friendlyLinkList: []
            }
        },
        created() {
            friendlyLink().then((res) => {
                if (res.code === 0) {
                    this.friendlyLinkList = res.rows
                }
            })
        }
    }
</script>

<style lang="less" scoped>
    .bottom {
        background: #0F141A;
        color: #777878;
        font-size: 14px;
    }

    .company {
        text-align: center;
    }

    .friend-link {
        width: 51%;
        color: #fff;
        font-size: 22px;
        margin: 16px auto;
    }
    .box {
        padding: 20px 0;

        div {
            /*height: 40px;*/
            line-height: 30px;
            a {
                font-size: 14px;
                color: #999999;
            }
            a:hover {
                color: #1DA57A;
            }
        }
    }


</style>
